import * as React from "react";
const SvgFiRrSkullCrossbones = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skull-crossbones_svg__a)">
      <path
        fill="#062147"
        d="M23.94 23.34a1 1 0 0 1-1.28.599L12 20.069l-10.659 3.87a.998.998 0 1 1-.682-1.88l8.411-3.053-8.41-3.053a1 1 0 0 1 .681-1.88l10.66 3.87 10.658-3.87a1 1 0 1 1 .682 1.88l-8.41 3.054 8.41 3.054a1 1 0 0 1 .6 1.28M9.5 9A1.5 1.5 0 1 0 9.5 5.999a1.5 1.5 0 0 0 .001 3m5 0a1.5 1.5 0 1 0-.001-3.001 1.5 1.5 0 0 0 .001 3M5 9V7.208C5 3.577 7.616.503 11.085.058a7.02 7.02 0 0 1 5.535 1.687A7 7 0 0 1 19 7v2c0 1.654-1.346 3-3 3 0 1.654-1.346 3-3 3h-2c-1.654 0-3-1.346-3-3-1.654 0-3-1.346-3-3m2 0c0 .55.45 1 1 1h1a1 1 0 0 1 1 1v1c0 .55.45 1 1 1h2c.551 0 1-.45 1-1v-1a1 1 0 0 1 1-1h1c.551 0 1-.45 1-1V7c0-1.434-.62-2.802-1.7-3.754a4.94 4.94 0 0 0-3.293-1.247 5 5 0 0 0-.668.043C8.865 2.359 7 4.58 7 7.208z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skull-crossbones_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkullCrossbones;
